import React from "react";
import { getImage, webpSrcSet, fallbackSrc } from "../helperFunctions/images";

// A plain <picture> for images that are not inside an antd Image.PreviewGroup.
// Unlike the portfolio grid — where antd renders its own <img> and can only take
// a srcSet — these can do real format negotiation with a JPEG fallback.
//
// width/height are set from the source dimensions so the browser reserves the
// right box before the file arrives; CSS still controls the rendered size.
const Photo = ({
  imageKey,
  alt = "",
  sizes = "100vw",
  className = "",
  // `display: contents` removes the <picture> box from layout, so the <img>
  // sizes against whatever container it was dropped into and callers can keep
  // using the same utility classes they had on a bare <img>.
  wrapperClassName = "contents",
  priority = false,
  ...rest
}) => {
  const entry = getImage(imageKey);
  if (!entry) return null;

  return (
    <picture className={wrapperClassName}>
      <source type="image/webp" srcSet={webpSrcSet(imageKey)} sizes={sizes} />
      <img
        src={fallbackSrc(imageKey)}
        alt={alt}
        width={entry.width}
        height={entry.height}
        loading={priority ? "eager" : "lazy"}
        decoding={priority ? "sync" : "async"}
        fetchpriority={priority ? "high" : undefined}
        className={className}
        {...rest}
      />
    </picture>
  );
};

export default Photo;
